// use-subscription-usage.ts — Subscription suite, query.

'use client';

import { ROUTE_CONTRACTS } from '@cabal/shared/api-client';
import type { GetSubscriptionUsageResponse } from '@cabal/shared/domain/billing/subscription/types.js';
import { useApi } from '@/contexts/api';
import { useRouteAuthEnabled } from '@/hooks/routing';
import { useQueryHook } from '@/lib/query/use-query-hook';
import type { QueryResult } from '@/types/async-protocol';
import { subscriptionKeys } from './keys';

export type SubscriptionUsage = GetSubscriptionUsageResponse;

export function useSubscriptionUsage(): QueryResult<SubscriptionUsage> {
  const api = useApi();
  const enabled = useRouteAuthEnabled({ route: ROUTE_CONTRACTS.subscription.usage });

  return useQueryHook<SubscriptionUsage, Error>({
    queryKey: subscriptionKeys.usage(),
    queryFn: () => api.subscription.usage(),
    options: { enabled },
  });
}
